import React from 'react';
import {GndiMinasAppIconProps} from './types';

export const GndiMinasAppIcon = ({size}: GndiMinasAppIconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		style={{minWidth: size || 34}}
		viewBox="0 0 64 64"
		fill="none">
		<rect width="64" height="64" fill="#1539AA" />
		<path
			d="M14.5926 20.501C12.8907 23.4458 14.9044 27.0056 19.9916 28.9621C22.6561 29.9862 27.1111 30.2021 30.0173 29.4169C29.2464 26.5079 26.8365 22.755 24.6183 20.9558C20.3849 17.5232 16.2946 17.5561 14.5926 20.501Z"
			fill="#FF4E05"
		/>
		<path
			d="M31.9938 8.5C28.3054 8.5 26.0557 12.3215 26.9796 18.1597C27.4644 21.2175 29.6798 25.5182 31.9938 27.8194C34.3079 25.5167 36.5233 21.2175 37.0081 18.1597C37.9335 12.323 35.6823 8.5 31.9938 8.5Z"
			fill="#FF222B"
		/>
		<path
			d="M49.4094 20.511C47.7117 17.5647 43.6199 17.529 39.3837 20.9572C37.164 22.7521 34.7498 26.5036 33.9775 29.4126C36.8823 30.1993 41.3373 29.989 44.0032 28.9664C49.0919 27.0156 51.1084 23.4572 49.4094 20.511Z"
			fill="#FF4E05"
		/>
		<path
			d="M31.9938 44.5C34.2636 44.5 35.6494 42.1473 35.0802 38.5546C34.7813 36.6724 33.4183 34.0251 31.9938 32.6092C30.5694 34.0265 29.2064 36.6724 28.9075 38.5546C28.3383 42.1473 29.7241 44.5 31.9938 44.5Z"
			fill="#FFCC23"
		/>
		<path
			d="M19.7156 37.4848C20.8497 39.4513 23.58 39.4756 26.4075 37.1873C27.8892 35.9888 29.501 33.4859 30.0159 31.5422C28.0765 31.0173 25.1031 31.1575 23.324 31.8397C19.9273 33.1412 18.5814 35.5168 19.7156 37.4848Z"
			fill="#FF8800"
		/>
		<path
			d="M44.2735 37.4905C45.4091 35.5254 44.0661 33.1484 40.6709 31.8426C38.8917 31.1575 35.9183 31.0145 33.979 31.5394C34.4938 33.4816 36.1028 35.9859 37.5816 37.1873C40.4077 39.4785 43.1379 39.4571 44.2735 37.4905Z"
			fill="#FF8800"
		/>
		<path
			d="M26.0518 47.5446H27.1213L29.0975 50.7298L30.9963 47.5446H32.0735V52.8611H30.9963V49.4201L29.485 51.9156H28.648L27.1213 49.4821V52.8611H26.0518V47.5446Z"
			fill="white"
		/>
		<path
			d="M36.1259 52.9773C35.5731 52.9773 35.0719 52.8533 34.6224 52.6053C34.1729 52.3573 33.819 52.0215 33.5607 51.5978C33.3023 51.169 33.1732 50.7014 33.1732 50.1951C33.1732 49.6939 33.2997 49.2315 33.5529 48.8078C33.8112 48.3842 34.1626 48.0483 34.6069 47.8003C35.0564 47.5523 35.5576 47.4283 36.1104 47.4283C36.5599 47.4283 36.9655 47.4955 37.3272 47.6298C37.6888 47.759 37.9859 47.9398 38.2184 48.1723C38.4561 48.3997 38.6137 48.658 38.6912 48.9473L37.6449 49.3193C37.5467 49.0352 37.3633 48.8208 37.0947 48.6761C36.8312 48.5314 36.5031 48.4591 36.1104 48.4591C35.7694 48.4591 35.4646 48.534 35.1959 48.6838C34.9324 48.8337 34.7257 49.0403 34.5759 49.3038C34.4261 49.5673 34.3512 49.8644 34.3512 50.1951C34.3512 50.5671 34.4338 50.8874 34.5992 51.1561C34.7697 51.4248 34.9944 51.6288 35.2734 51.7683C35.5576 51.9078 35.865 51.9776 36.1957 51.9776C36.5935 51.9776 36.9474 51.8743 37.2574 51.6676C37.5674 51.4558 37.7508 51.1793 37.8077 50.8383H36.0019V49.9161H38.9469C38.9624 49.9988 38.9702 50.1202 38.9702 50.2803C38.9702 50.8022 38.8513 51.2698 38.6137 51.6831C38.3812 52.0913 38.0505 52.409 37.6217 52.6363C37.1928 52.8637 36.6942 52.9773 36.1259 52.9773Z"
			fill="white"
		/>
	</svg>
);
